/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Disable_Account_LabelInputs */

const en_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable Account`)
};

const fr_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver le compte`)
};

const de_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto deaktivieren`)
};

const it_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabilita account`)
};

const ru_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отключить учетную запись`)
};

const es_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshabilitar cuenta`)
};

const zh_cn2_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`禁用帐户`)
};

const ja_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを無効にする`)
};

const hi_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता निष्क्रिय करें`)
};

const pt_pt2_team_manager_disable_account_label = /** @type {(inputs: Team_Manager_Disable_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar conta`)
};

/**
* | output |
* | --- |
* | "Disable Account" |
*
* @param {Team_Manager_Disable_Account_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_disable_account_label = /** @type {((inputs?: Team_Manager_Disable_Account_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Disable_Account_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_disable_account_label(inputs)
	if (locale === "de") return de_team_manager_disable_account_label(inputs)
	if (locale === "it") return it_team_manager_disable_account_label(inputs)
	if (locale === "ru") return ru_team_manager_disable_account_label(inputs)
	if (locale === "es") return es_team_manager_disable_account_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_disable_account_label(inputs)
	if (locale === "ja") return ja_team_manager_disable_account_label(inputs)
	if (locale === "hi") return hi_team_manager_disable_account_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_disable_account_label(inputs)
	return en_team_manager_disable_account_label(inputs)
});